import * as STD                          from '@emersya/mpa-std-lib';
import CM                                from '@emersya/mpa-components-manager-lib';
import { InputButton, Image, InputBool } from '@emersya/mpa-components-lib';

export interface INumericOptionsButtonComponentConfiguration extends InputButton.Configuration {
};

export class NumericOptionsButtonComponent extends InputButton.Component {


	async onValueUpdated(ev : STD.events.Event<any, CM.Component<any, any>>) {
		if (ev.details.isDefaultValue) {
			return;
		}
		if (this.component_DOM.classList.contains('notReady')) {
			return;
		}
		await app.modals.useModal('modalNumericOptions', void 1);
	};

	private async resetBasket() {
		if (!app.currentProduct) {
			return;
		}
		const parts = app.currentProduct.parts.filter(x => x.id.startsWith('numericOptions'));
		if (parts.length) {
			const bools = Array.from(document.querySelectorAll('[data-component-id=modalNumericOptions] .component-input-bool')).
			map<InputBool.Component>(x => (<any> x).details.component);
			for (const bool of bools) {
				if (bool.value) {
					await bool.updateValue(false);
				}
			}
		}
	};

	async updateAvailability() {
		const multimedia = app.viewer.categories.find(x => x.name === 'multimedia');
		if (!multimedia) {
			this.component_throwUserError('Missing multimedia category');
		}
		const numberOfInstance = multimedia.products.map(x => x.instances.size).flat().reduce((a, c) => a + c, 0);
		if (numberOfInstance > 0) {
			this.component_DOM.classList.remove('notReady');
		} else {
			this.component_DOM.classList.add('notReady');
			await this.resetBasket();
		}
	}

	override async component_start(ev : STD.events.Event<any, CM.Component<any, any>>) {
		await super.component_start(ev);
		this.component_DOM.classList.add('notReady');
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : INumericOptionsButtonComponentConfiguration
	)
	{
		configuration[ '@innerConfigurations' ] = {
			icon : <Image.Configuration> {
				URL : (<any> window).serverParameters.app.assetsPath + 'icon-TV.svg'
			}
		}
		super(descriptor, configuration);
	};
};
export namespace NS {
	export const Component = NumericOptionsButtonComponent;
	export type Component = NumericOptionsButtonComponent;
	export type Configuration = INumericOptionsButtonComponentConfiguration;
}
import manifestXMLSource                 from './StandingButtonNumericOptions.xml';
import './StandingButtonNumericOptions.scss';

CM.declare({
	id :       'standingButtonNumericOptions',
	type :     NumericOptionsButtonComponent,
	manifest : manifestXMLSource
});
